import { Image } from "@src/components/Image";
import { useRouter } from "@src/lib/router";
import React, { forwardRef } from "react";
import { useDispatch, useSelector } from "react-redux";
import { directDeepLink } from "@src/common/deepLinks";
import { getAwsAssets } from "@src/utils";
import handleBackEvent from "@src/utils/goBack";
import { showShareContentViaBottomSheetAction } from "@src/components/BottomSheets/store/actions.js";
// import styles from "./Layout.module.scss";
import { newWebEngage } from "@src/utils/webEngageEvent";
import { USER_AGENT_STRING } from "@src/utils/constants";

function LayoutHeader(
  { accent, marginTop, handleBack, pageHeadingServer },
  ref
) {
  const router = useRouter();
  const dispatch = useDispatch();
  const pageHeading = useSelector((state) => state?.layoutReducer?.heading);
  const socialLinks = useSelector(
    (state) => state?.overviewReducer?.overViewDetails?.course?.socialLinks
  );
  const isStandAlone = useSelector(
    (state) => state?.overviewReducer?.overViewDetails?.course?.metaData?.doubtBuddyCourseFlag) || false;

  const encodedSocialLinks = { ...socialLinks };

  const deviceType = useSelector(
    (state) => state?.persistedDataReducer?.deviceType
  );

  // console.log(deviceType, "this is deviceType");
  const handleShare = () => {
    newWebEngage("course_share_click", {
      action: "Single Share Click",

    });
    deviceType == USER_AGENT_STRING.IOS
      ? directDeepLink(
        {
          action: "ACTION_SHARE_COURSE",
        },
        "ACTION_SHARE_COURSE",
        false
      )({ socialLinks })
      : dispatch(showShareContentViaBottomSheetAction(true));
  }
  return (
    <div
      className={`layoutHeader ${accent && "layoutHeader--accent"} `}
      ref={ref}
      style={{ marginTop: `${marginTop}px`, backgroundColor: (isStandAlone || accent )  ? '#009AE0' : 'white' , color:isStandAlone || accent ? 'white': '#3c4852' }} 
    >
      <div className="layoutHeader__left">
        <div
          className="layoutHeader__left__back"
          onClick={() => handleBackEvent(handleBack)}
        >
          <Image
            src={getAwsAssets(
              `leftArrowIcon${accent || isStandAlone ? "Accent" : ""}.svg`,
              "layout"
            )}
            alt="leftArrowIcon"
            height={16}
            width={16}
            layout="fixed"
            priority={true}
            loading="eager"
          />
        </div>
        <h1>{ pageHeading || pageHeadingServer }</h1>
      </div>

      {router?.query?.tabId && !isStandAlone &&(
        <Image
          className="layoutHeader__shareIcon"
          src={getAwsAssets(`shareIcon.svg`, "layout")}
          alt="shareIcon"
          height={24}
          width={24}
          layout="fixed"
          priority={true}
          loading="eager"
          onClick={() => {

            handleShare();

          }
          }
        />
      )}
    </div>
  );
}

const Header = forwardRef(LayoutHeader);

export default React.memo(Header);
